import MobilePreviewImg from '@/components/Mobile/PreviewImg';
const MobileImg = ({ src }) => {
    return (
        <div className="mobile-img-block">
            <MobilePreviewImg src={src} />
        </div>
    );
};

export default MobileImg;
